<button class="md:tw-py-2 tw-py-2 md:tw-pl-2 tw-w-auto tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-center md:tw-justify-start md:tw-w-full" (click)="onButtonClick()">
  <div><fa-icon [icon]="icon" class="md:tw-mr-4 tw-text-lg"></fa-icon></div>
  <div class="tw-text-sm  md:tw-pr-4" style="word-break: keep-all;">{{label}}</div>
</button>
